import { eventTracker } from 'app/modules/Segment';
import {
  buildJusfyEventsContext,
  buildJusfyEventsProperties,
} from 'app/modules/Segment/buildJusfyEvent';
import {
  FeatureEnum,
  TContext,
  TProperties,
} from 'app/modules/Segment/types';

const EVENTS = {
  ONBOARDING_CHECKLIST_VIEWED: 'onboarding_checklist_viewed',
  ONBOARDING_CHECKLIST_ITEM_CLICKED: 'onboarding_checklist_item_clicked',
} as const;

const onboardingChecklistContext: TContext = buildJusfyEventsContext({
  component: 'onboarding-checklist',
});

function trackOnboardingChecklistEvent(
  event: string,
  relevantUserActivity: boolean,
  eventMeaning: string,
  additionalProperties?: Record<string, unknown>,
): void {
  const properties: TProperties = buildJusfyEventsProperties({
    event,
    feature: FeatureEnum.ONBOARDING,
    eventMeaning,
    relevantUserActivity,
    extraProperties: additionalProperties,
  });

  eventTracker.track({
    event,
    properties,
    context: onboardingChecklistContext,
  });
}

export function trackOnboardingChecklistViewed(
  itemsTotal: number,
  itemsCompleted: number,
): void {
  trackOnboardingChecklistEvent(
    EVENTS.ONBOARDING_CHECKLIST_VIEWED,
    false,
    '[Onboarding] Checklist de primeiros passos exibido no dropdown de gamificação.',
    { items_total: itemsTotal, items_completed: itemsCompleted },
  );
}

export function trackOnboardingChecklistItemClicked(
  itemName: string,
  itemEvent: string,
): void {
  trackOnboardingChecklistEvent(
    EVENTS.ONBOARDING_CHECKLIST_ITEM_CLICKED,
    true,
    '[Onboarding] Usuário clicou num item pendente do checklist de primeiros passos.',
    { item_name: itemName, item_event: itemEvent },
  );
}

export { EVENTS as ONBOARDING_CHECKLIST_EVENTS };
